module.exports = __webpack_public_path__ + "img/94033.a9393de1.svg";